// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1i_Yw","footer":"ModalCreateQualiphyProcedure_footer__2IXEt","additionData":"ModalCreateQualiphyProcedure_additionData__2q9aW"};